import { render, staticRenderFns } from "./saleHeader.vue?vue&type=template&id=10e8662f"
import script from "./saleHeader.vue?vue&type=script&lang=js"
export * from "./saleHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports